import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _Key;
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Key from '@crehana/compass.icons.outline/Key';
import { clsx } from 'clsx';
import { PermissionsDetail } from "./PermissionsDetail";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var UserPermissions = function UserPermissions(_ref) {
  var organizationSlug = _ref.organizationSlug;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
  }, [isOpen]);
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-pt-2",
    children: [/*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: function onClick() {
        return setIsOpen(!isOpen);
      },
      className: clsx('tw-w-full tw-group tw-h-3.6 tw-px-1.2 tw-flex tw-items-center tw-justify-center tw-font-link1 tw-gap-0.8 tw-transition-colors', 'tw-rounded-1 tw-border tw-border-solid tw-border-neutral-light-500 dark:tw-border-neutral-dark-700', 'tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700', 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100', 'hover:tw-border-primary-light-500 hover:tw-text-primary-light-500 dark:hover:tw-border-secondary-light-500 dark:hover:tw-text-secondary-light-500', 'active:tw-bg-primary-light-500 active:tw-text-neutral-light-100 dark:active:tw-bg-secondary-light-500 dark:active:tw-text-elevation-dark-02', 'aria-expanded:tw-bg-primary-light-500 aria-expanded:tw-text-neutral-light-100 dark:aria-expanded:tw-bg-secondary-light-500 dark:aria-expanded:tw-text-elevation-dark-02', 'disabled:tw-bg-neutral-light-400 disabled:tw-text-neutral-light-600 disabled:tw-border-neutral-light-400 dark:disabled:tw-bg-neutral-dark-500 dark:disabled:tw-text-neutral-dark-600 dark:disabled:tw-border-neutral-dark-500'),
      children: [_Key || (_Key = /*#__PURE__*/_jsx(Key, {
        size: 16,
        className: "tw-text-current"
      })), "Ver permisos"]
    }), /*#__PURE__*/createPortal(/*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: clsx('tw-fixed tw-inset-0', isOpen ? 'tw-visible tw-z-dialog' : 'tw-hidden'),
        style: {
          top: '62px',
          background: 'rgba(223, 226, 253, 0.50)',
          backdropFilter: 'blur(4px)'
        },
        tabIndex: -1
      }), /*#__PURE__*/_jsx(PermissionsDetail, {
        isOpen: isOpen,
        close: function close() {
          return setIsOpen(false);
        },
        organizationSlug: organizationSlug
      })]
    }), document.body)]
  });
};